export default __webpack_public_path__ + "static/media/IMG_7931.4964ec84.JPG";